import React from "react";

export default function CheckoutDiscount() {
  return <>CheckoutDiscount</>;
}
